import { computed, makeObservable, observable } from 'mobx'
import {
  Beer,
  Locale,
  LocalisedAllergen,
  LocalisedUnit,
  Restaurant,
} from '../../__generated__/graphql'
import { MessageModel, UserModel } from './models'

class Store {
  user?: UserModel
  localisedAllergens?: LocalisedAllergen[]
  localisedUnits?: LocalisedUnit[]
  locales?: Locale[]
  activeLocale?: string
  activeLocaleSetAutomatically?: boolean = false
  messages?: MessageModel[]
  currentRestaurant?: Restaurant
  beersForBeerSelection?: Beer[]

  constructor() {
    makeObservable(this, {
      activeAllergens: computed,
      activeUnits: computed,
      user: observable.ref,
      localisedAllergens: observable.ref,
      localisedUnits: observable.ref,
      locales: observable.ref,
      activeLocale: observable.ref,
      activeLocaleSetAutomatically: observable.ref,
      messages: observable.ref,
      currentRestaurant: observable.ref,
      beersForBeerSelection: observable.ref,
    })
  }

  get activeAllergens() {
    const locale = this.activeLocale
    return this.localisedAllergens
      ?.filter((allergen) => allergen.locale.locale === locale)
      .map(($) => $.allergens)[0]
  }

  get activeUnits() {
    const locale = this.activeLocale
    return this.localisedUnits
      ?.filter((unit) => unit.locale.locale === locale)
      .map(($) => $.units)[0]
  }
}

export const AppStore = new Store()
